import { RegexThreeDigitsSeparator } from 'src/utils/regularExpression'
import { fullHyphenToHalf, fullToHalf } from 'src/utils/string'

const removeNonNumericCharactersExceptSomeCharacters = (str: string) => {
  // 先頭の一文字だけハイフンを許容する
  const firstChar = str.charAt(0).replace(/[^\d０-９ー-]/g, '')
  // 先頭の一文字を除いて、数字と全角数字と.以外の文字を削除する
  const processedStr = str.slice(1).replace(/[^\d０-９.]|(\.[^.]*)\.*/g, '$1')

  // 小数点で文字列を分割
  const [integerPart, fractionalPart] = (firstChar + processedStr).split('.')

  // 小数部分から数字以外の文字を除去するのと、最大2桁まで取得
  const cleanedFractionalPart = fractionalPart
    ? fractionalPart.replace(/[^\d０-９]/g, '').slice(0, 2)
    : ''

  // 結果を組み立て(末尾のピリオドを保持)
  return `${integerPart}${
    cleanedFractionalPart || str.endsWith('.') ? '.' : ''
  }${cleanedFractionalPart}`
}

// NOTE: カーソル位置を「整形後に残る文字（数字・小数点・ハイフン）の個数」で扱う関数。
//
// カンマは3桁区切りの表示上の飾りで、入力に応じて自動で増減する。
// カーソル位置をそのままの文字インデックスで補正しようとすると、カンマの増減量に
// 一律で追従させる必要があり、全置換や桁区切りをまたぐ中間挿入でずれてしまう
// （例: 全選択した "1,000" を打鍵順どおりに置換できず 231 になる／"1,000" の
// 先頭桁直後で入力すると 195,000 が 159,000 に並び替わる）。
//
// そこで「カーソルより左にある、整形後に残る文字の個数」を基準にする。
// この個数さえ保てば、整形後のどの位置にカーソルを戻すべきかを一意に決められる。
// 小数点・ハイフンも残る文字として自然に数えられるため、専用の分岐は不要。

// NOTE: valueWithComma で、左から count 個目の「カンマ以外の文字」の直後の位置を返す。
// 直後がカンマでもそこで止め、カンマの手前に置く（カンマの右へ送ると、カンマ直後の
// Backspaceでカーソルが変化せず補正が効かず、末尾へ飛ぶデグレになるため）。
export const getCursorPositionFromNonCommaCount = (
  valueWithComma: string,
  count: number
): number => {
  if (count <= 0) return 0

  let counted = 0
  for (let i = 0; i < valueWithComma.length; i += 1) {
    if (valueWithComma[i] !== ',') {
      counted += 1
      if (counted === count) {
        return i + 1
      }
    }
  }
  // 数字が足りない場合は末尾に置く
  return valueWithComma.length
}

export const getValueWithComma = (valueWithoutComma: string): string => {
  return valueWithoutComma.replace(RegexThreeDigitsSeparator, ',')
}

export const getHalfWidthNumericString = (inputValue: string): string => {
  const numericStringWithoutComma =
    removeNonNumericCharactersExceptSomeCharacters(inputValue)

  if (!numericStringWithoutComma) return ''

  const convertedWithoutFullHyphen = fullHyphenToHalf(numericStringWithoutComma)

  return fullToHalf(convertedWithoutFullHyphen)
}
